<script setup lang="ts">
defineProps<{
    type: string;
}>();

const typeDetails = {
    '1': {
        image: 'slightly_frowning_face.svg',
        title: 'We’re Sorry for Your Experience.',
        description: 'We didn’t meet your expectations, and we sincerely apologize. Please let us know what went wrong so we can make it right.',
    },
    '2': {
        image: 'slightly_frowning_face.svg',
        title: 'We’re sorry to hear that.',
        description: 'We’re sorry to hear that your experience did not meet your expectations. We take your concerns seriously and are committed to making things right.',
    },
    '3': {
        image: 'thanks.svg',
        title: 'Thanks for sharing!',
        description: 'We appreciate your honesty and would love to know how we can make your next visit a better one.',
    },
    '4': {
        image: 'heart_eyes.svg',
        title: 'Great to hear!',
        description: 'Is there anything we can do to make your next visit even better?',
    },
    '5': {
        image: 'heart_eyes.svg',
        title: 'Great to hear!',
        description: 'We’re thrilled you had a great experience! Many people around you may be looking for the same kind of care.',
    },
}
</script>

<template>
    <div>
        <img :src="`/${typeDetails[type].image}`" class="size-10 mb-4" />
        <div class="mt-1 font-bold text-lg text-gray-800">{{ typeDetails[type].title }}</div>
        <p class="mt-1 font-medium text-gray-800">{{ typeDetails[type].description }}</p>
    </div>
</template>
